import { RootState } from "../adapters/react/store";

// Boolean selectors for specific login statuses
export const selectLoginStatus = (state: RootState) => state.auth.loginStatus;
export const selectIsAuthPending = (state: RootState) => state.auth.loginStatus === "pending";

// Combined selectors
export const selectIsAuthSuccessOrPerpetual = (state: RootState) =>
  state.auth.loginStatus === "success" || state.auth.loginStatus === "perpetual";
export const selectLeadStatus = (state: RootState) => state.auth.leadStatus;

export const selectIsCommonSsoModalVisible = (state: RootState) =>
  state.auth.isCommonSsoModalVisible;

export const selectSsoRedirectUrl = (state: RootState) => state.auth.ssoRedirectUrl;
